import React, { useEffect, useState } from 'react';
import axios from 'axios';
import NavLink from './common/NavLink';
import CustomSelect from './CustomSelect';
import RequireVip from './RequireVip'
import { slugify } from '../utils/slugify'; 
import { useParams } from 'react-router-dom';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormControl, Select, MenuItem, InputLabel } from '@mui/material';

const Fixtures = () => {
  const { competitionId } = useParams();
  const [matches, setMatches] = useState([]);
  const [filteredMatches, setFilteredMatches] = useState([]);
  const [teams, setTeams] = useState([]);
  const [leagueName, setLeagueName] = useState('');
  const [statsRequirement, setStatsRequirement] = useState('');
  const [fullRequirement, setFullRequirement] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedRound, setSelectedRound] = useState('all');
  const [selectedTeamId, setSelectedTeamId] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/league/${competitionId}`);
        const data = response.data;

        const uniqueRounds = [...new Set(data.matches.map(match => match.round).filter(round => round !== null))].sort((a, b) => a - b);
        const sortedMatches = [...(data.matches || [])].sort((a, b) => {
          const dateA = a.matchDate ? new Date(a.matchDate).getTime() : Infinity;
          const dateB = b.matchDate ? new Date(b.matchDate).getTime() : Infinity;

          if (dateA !== dateB) {
            return dateA - dateB;
          }

          return a.round - b.round;
        });
		setStatsRequirement(data.statsRequirement || '');
		setFullRequirement(data.fullRequirement || '');
        setMatches(sortedMatches);
        setTeams(data.teams || []);
        setFilteredMatches(sortedMatches);

        if (data.teams && data.teams.length > 0) {
          setLeagueName(data.teams[0].competitionId || 'Nieznana liga');
        } else {
          setLeagueName('Nieznana liga');
        }

        setLoading(false);
      } catch (err) {
        setError('Błąd podczas pobierania danych meczów.');
        console.error(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [competitionId]);

  useEffect(() => {
	  let filtered = [...matches];

	  if (selectedStatus !== 'all') {
		filtered = filtered.filter(match => match.status === selectedStatus);
	  }

	  if (selectedRound !== 'all') {
		filtered = filtered.filter(match => {
		  console.log('Match round:', match.round, 'Selected round:', selectedRound); // Debugowanie
		  return match.round === selectedRound;
		});
	  }

	  if (selectedTeamId !== 'all') {
		filtered = filtered.filter(match => {
		  console.log('Match team IDs:', { home: match.homeTeamId, away: match.awayTeamId }, 'Selected team ID:', selectedTeamId); // Debugowanie
		  return match.homeTeamId === selectedTeamId || match.awayTeamId === selectedTeamId;
		});
	  }

	  if (sortConfig.key) {
		filtered = [...filtered].sort((a, b) => {
		  const direction = sortConfig.direction === 'asc' ? 1 : -1;
		  if (sortConfig.key === 'matchDate') {
			const dateA = a.matchDate ? new Date(a.matchDate).getTime() : Infinity;
			const dateB = b.matchDate ? new Date(b.matchDate).getTime() : Infinity;
			if (dateA === Infinity && dateB === Infinity) return 0;
			if (dateA === Infinity) return 1;
			if (dateB === Infinity) return -1;
			return (dateA - dateB) * direction;
		  }
		  const valueA = a[sortConfig.key] || '';
		  const valueB = b[sortConfig.key] || '';
		  if (typeof valueA === 'string') {
			return valueA.localeCompare(valueB) * direction;
		  }
		  return (valueA - valueB) * direction;
		});
	  }

	  setFilteredMatches(filtered);
}, [selectedStatus, selectedRound, selectedTeamId, matches, sortConfig]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleRoundChange = (event) => {
    setSelectedRound(event.target.value);
  };

  const handleTeamChange = (event) => {
    setSelectedTeamId(event.target.value);
  };
  
  const statusOptions = [
		  { value: 'all', label: 'Wszystkie' },
		  { value: 'planned', label: 'Planowane' },
		  { value: 'ended', label: 'Zakończone' },
		];
		
 const roundOptions = [
  { value: 'all', label: 'Wszystkie' },
  ...[...new Set(matches.map(match => match.round))]
    .filter(round => round !== undefined && round !== null && round !== '') // Opcjonalne zabezpieczenie przed pustymi polami
    .sort((a, b) => {
      const isANumeric = !isNaN(a) && !isNaN(parseFloat(a));
      const isBNumeric = !isNaN(b) && !isNaN(parseFloat(b));

      if (isANumeric && isBNumeric) {
        return parseFloat(a) - parseFloat(b); // Obie są liczbami -> sortowanie numeryczne
      }
      if (isANumeric) return -1; // Liczby idą na początek
      if (isBNumeric) return 1;  // Tekst idzie na koniec

      return a.toString().localeCompare(b.toString()); // Obie to tekst -> sortowanie alfabetyczne (np. tekstowe)
    })
    .map(round => {
      const isNumeric = !isNaN(round) && !isNaN(parseFloat(round));
      return {
        value: round.toString(),
        // Jeśli liczba: "Kolejka X", jeśli tekst (np. "Finał"): zostawia sam tekst
        label: isNumeric ? `Kolejka ${round}` : round.toString(),
      };
    }),
];
  
  const teamOptions = [
    { value: 'all', label: 'Wszystkie' },
    ...teams.map(team => ({
      value: team.teamId,
      label: team.teamName,
    })),
  ];
  

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: { xs: '0px', md: '0px' } }}>
      <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
        Terminarz - {leagueName}
      </Typography>
	  
	  

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 3,
          mb: 3,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
		<CustomSelect
		  labelId="status-select-label"
		  label="Status"
		  value={selectedStatus}
		  onChange={handleStatusChange}
		  options={statusOptions}
		/>
		
        <CustomSelect
		  labelId="round-select-label"
		  label="Kolejka"
		  value={selectedRound}
		  onChange={handleRoundChange}
		  options={roundOptions}
		/>

        <CustomSelect
		  labelId="team-select-label"
		  label="Drużyna"
		  value={selectedTeamId}
		  onChange={handleTeamChange}
		  options={teamOptions}
		/>
      </Box>

      {filteredMatches.length === 0 ? (
        <Typography variant="h5" gutterBottom>
          Brak meczów spełniających wybrane kryteria.
        </Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            width: 'fit-content',
            margin: '0 auto',
            overflowX: 'auto',
            borderRadius: '12px',
          }}
        >
          <Table sx={{ width: 'auto' }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('round')}>
                  # {sortConfig.key === 'round' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('homeTeamName')}>
                  Gospodarze {sortConfig.key === 'homeTeamName' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('homeGoals')}>
                  Wynik {sortConfig.key === 'homeGoals' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('awayTeamName')}>
                  Goście {sortConfig.key === 'awayTeamName' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('p1')}>
                  1 {sortConfig.key === 'p1' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('px')}>
                  X {sortConfig.key === 'px' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('p2')}>
                  2 {sortConfig.key === 'p2' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
                <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, cursor: 'pointer' }} onClick={() => handleSort('matchDate')}>
                  Data {sortConfig.key === 'matchDate' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredMatches.map((match) => {
                let highlightedProb = null;
                if (match.status === 'ended') {
                  if (match.homeGoals > match.awayGoals) highlightedProb = 'p1';
                  else if (match.homeGoals === match.awayGoals) highlightedProb = 'px';
                  else if (match.homeGoals < match.awayGoals) highlightedProb = 'p2';
                }

                const newHomeElo = match.status === 'ended' ? match.homeElo + match.eloChange : null;
                const newAwayElo = match.status === 'ended' ? match.awayElo - match.eloChange : null;
                const homeEloChangeDisplay = match.status === 'ended' ? (match.eloChange >= 0 ? `(+${match.eloChange})` : `(-${Math.abs(match.eloChange)})`) : '';
                const awayEloChangeDisplay = match.status === 'ended' ? (match.eloChange >= 0 ? `(-${match.eloChange})` : `(+${Math.abs(match.eloChange)})`) : '';

                return (
                  <TableRow key={match.matchId}>
                    <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' } }}>{match.round}</TableCell>
                    <TableCell align="center" component={NavLink}
					to={`/team/${match.homeTeamId}/${slugify(match.homeTeamName)}`} sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, fontWeight: 'bold' }}>
                      {match.homeTeamName}
                      <RequireVip variant="nothing" requirement={statsRequirement}>
						  <Typography component="span" sx={{ display: 'block', fontSize: { xs: '0.6rem', sm: '0.8rem' }, color: '#B0BEC5', fontWeight: 'normal' }}>
							{match.status === 'ended' ? `${match.homeElo} --> ${newHomeElo} ${homeEloChangeDisplay}` : `(${match.homeElo})`}
						  </Typography>
					  </RequireVip>
                    </TableCell>
                    <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, fontWeight: 'bold' }}>
                      {match.status === 'ended' ? `${match.homeGoals} - ${match.awayGoals}` : '-'}
                    </TableCell>
                    <TableCell component={NavLink}
					to={`/team/${match.awayTeamId}/${slugify(match.awayTeamName)}`} align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' }, fontWeight: 'bold' }}>
                      {match.awayTeamName}
                      <RequireVip variant="nothing" requirement={statsRequirement}>
						  <Typography component="span" sx={{ display: 'block', fontSize: { xs: '0.6rem', sm: '0.8rem' }, color: '#B0BEC5', fontWeight: 'normal' }}>
							{match.status === 'ended' ? `${match.awayElo} --> ${newAwayElo} ${awayEloChangeDisplay}` : `(${match.awayElo})`}
						  </Typography>
					  </RequireVip>	  
                    </TableCell>
					<TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' } }}>
						<RequireVip variant="blur" requirement={statsRequirement}>
						  <span style={{ border: highlightedProb === 'p1' ? '2px solid #4CAF50' : 'none', padding: highlightedProb === 'p1' ? '2px 4px' : '0' }}>
							{match.p1}%
						  </span>
						 </RequireVip>
					</TableCell>												
					<TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' } }}>
					    <RequireVip variant="blur" requirement={statsRequirement}>
						  <span style={{ border: highlightedProb === 'px' ? '2px solid #4CAF50' : 'none', padding: highlightedProb === 'px' ? '2px 4px' : '0' }}>
							{match.px}%
						  </span>
						</RequireVip>  
					</TableCell>				
					<TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' } }}>
						<RequireVip variant="blur" requirement={statsRequirement}>
						  <span style={{ border: highlightedProb === 'p2' ? '2px solid #4CAF50' : 'none', padding: highlightedProb === 'p2' ? '2px 4px' : '0' }}>
							{match.p2}%
						  </span>
					    </RequireVip>
					</TableCell>					
                    <TableCell align="center" sx={{ padding: { xs: '4px', sm: '8px' }, fontSize: { xs: '0.7rem', sm: '0.9rem' } }}>{match.matchDate || ''}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Fixtures;